import React, { useState, useContext, useEffect } from "react";
import ProductContext from "../../context/products/ProductContext";
import AlertContext from "../../context/alert/AlertContext";
import AuthContext from "../../context/auth/AuthContext";

const ProductForm = () => {
  const productContext = useContext(ProductContext);
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const {
    products,
    addProduct,
    deleteProduct,
    clearCurrent,
    updateProduct,
    current,
    clearFilter,
  } = productContext;
  const { setAlert } = alertContext;
  const { clearErrors } = authContext;

  useEffect(() => {
    // set up initial state upon loading
    if (current !== null) {
      setProduct({
        ProductRecordID: current._id,
        ProductID: current.product_id,
        ProductDescription: current.product_description,
        ProductShippingUS: current.product_shipping_us,
        ProductShippingNUS: current.product_shipping_nus,
        USPS: current.USPS,
        ProductPrice: current.product_price,
      });
      setFields(current.product_price);
    } else {
      setProduct({
        ProductID: "",
        ProductDescription: "",
        ProductShippingUS: "",
        ProductShippingNUS: "",
        USPS: "",
        ProductPrice: [{}],
        price: "",
        quantity: "",
      });
    }
  }, [productContext, current]);

  const [product, setProduct] = useState({
    ProductID: "",
    ProductDescription: "",
    ProductShippingUS: "",
    ProductShippingNUS: "",
    USPS: "",
    ProductPrice: [{}],
    loading: true,
    price: "",
    quantity: "",
  });

  const {
    ProductID,
    ProductDescription,
    ProductShippingUS,
    ProductShippingNUS,
    USPS,
    ProductPrice,
  } = product;

  const onChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    var CheckID = products
      .filter((item) => item.product_id == product.ProductID)
      .map(({ product_id }) => ({
        product_id,
      }));

    var CurrentTime = new Date().toISOString();
    CurrentTime = CurrentTime.slice(0, -5) + "+08:00";

    if (
      product.ProductID !== "" &&
      product.ProductDescription !== "" &&
      product.ProductShippingUS !== "" &&
      product.ProductShippingNUS !== "" &&
      Object.values(product.ProductPrice).length !== 0
    ) {
      var arr = [];
      removeWhiteSpaces();

      for (var key in product.ProductPrice) {
        var check = Object.values(product.ProductPrice[key]);

        if (check[0] === undefined || check[0].length === 0) {
          setAlert("Product Price Incomplete", "danger");
          clearErrors();
          return;
        }

        if (Object.keys(product.ProductPrice[key])[0] === "") {
          setAlert("Product Price Incomplete", "danger");
          clearErrors();
          return;
        }

        arr.push(Object.keys(product.ProductPrice[key])[0]);

        if (arr.length > 1) {
          var counts = [];
          for (var i = 0; i <= arr.length; i++) {
            if (counts[arr[i]] === undefined) {
              counts[arr[i]] = 1;
            } else {
              setAlert("Product Quantity Consists of Duplicates", "danger");
              clearErrors();
              return;
            }
          }
        }
      }

      if (current === null) {
        product.created_at = CurrentTime;
        if (CheckID.length === 0) {
          product.ProductPrice.sort(compare);
          addProduct(product);
          clearAll();
          setProduct({
            ProductID: "",
            ProductDescription: "",
            ProductShippingUS: "",
            ProductShippingNUS: "",
            USPS: "",
            ProductPrice: null,
            price: "",
            quantity: "",
            alert_arr_fields_incomplete: [],
            alert_arr_name: [],
            alert_arr_price: [],
            alert_arr_proQuantity: [],
            alert_arr_quantityInputError: [],
          });
        } else {
          setAlert("Same Product ID already exists", "danger");
          clearErrors();
        } // same product id exists
      } else {
        var RefinedList = products.filter(function (products) {
          //  make sure current record is not taken into account when checking product id across the list
          return products._id !== product.ProductRecordID;
        });

        var CheckID = RefinedList.filter(
          (item) => item.product_id == product.ProductID
        ).map(({ product_id }) => ({
          product_id,
        }));

        if (CheckID.length === 0) {
          product.updated_at = CurrentTime;
          product.ProductPrice.sort(compare);
          updateProduct(product);
          clearAll();
        } else {
          setAlert("Same Product ID already exists", "danger");
          clearErrors();
        } // same product id exists
      }
    } else {
      setAlert(
        "Please fill in all fields & at least 1 product price.",
        "danger"
      );
      clearErrors();
    } // first three fields not filled in
  };

  // function to arrange product prices while saving according to product quantity
  function compare(a, b) {
    const itemA = Object.keys(a)[0];
    const itemB = Object.keys(b)[0];

    return itemA - itemB;
  }

  const removeWhiteSpaces = (e) => {
    for (var key in product) {
      if (typeof product[key] !== "object") {
        if (key !== "ProductDescription") {
          var value = product[key];
          value = value.toString().replace(/ +?/g, "");
          product[key] = value;
        }
      }
    }
  };

  const onDelete = (e) => {
    e.preventDefault();
    deleteProduct(product.ProductRecordID);
    clearAll();
  };

  const clearAll = () => {
    // function of "clear" button
    clearCurrent(product);
    clearCurrent();
    clearFilter();
    setFields([{}]);
  };

  const [fields, setFields] = useState([{}]);

  const handleQuantityChange = (i, event) => {
    const values = [...fields];
    const re = /^[0-9\b]+$/;

    if (re.test(event.target.value) === true || event.target.value === "") {
      if (values[i] === null) {
        values[i][event.target.value] = "";
      } else {
        var price = Object.values(values[i])[0];
        values[i] = {};
        values[i][event.target.value] = price;
      }
      setFields(values);
      setProduct((product) => ({
        ...product,
        ProductPrice: values,
      }));
    } else {
      setAlert("Quantity Only Accept Whole Number.", "danger");
      clearErrors();
    }
  };

  const handlePriceChange = (i, event) => {
    const values = [...fields];
    var quantity = Object.keys(values[i]);
    values[i] = {};
    values[i][quantity] = event.target.value;
    setFields(values);
    setProduct((product) => ({
      ...product,
      ProductPrice: values,
    }));
  };

  const handleAdd = (e) => {
    const values = [...fields];
    values.push({});
    setFields(values);
  };

  const handleRemove = (e) => {
    const values = [...fields];
    values.splice(e, 1);
    setFields(values);
    setProduct((product) => ({
      ...product,
      ProductPrice: values,
    }));
  };

  return (
    <div className="container">
      <form onSubmit={onSubmit}>
        <div className="row justifyContent-content-start">
          <div className="col-sm-auto">
            <h1 className="text-dark">
              {" "}
              {current ? "Edit Product" : "Add Product"}{" "}
            </h1>{" "}
          </div>{" "}
        </div>
        <div className="input-group input-group-sm mb-3">
          <div className="form-control col-12 col-md-6 col-lg-3 text-center">
            <label> Product ID </label>{" "}
          </div>{" "}
          <input
            className="form-control col-6 col-md-6 col-lg-9"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-sm"
            type="text"
            name="ProductID"
            value={ProductID}
            onChange={onChange}
          />{" "}
        </div>{" "}
        <div className="input-group input-group-sm mb-3">
          <div className="form-control col-12 col-md-6 col-lg-3 text-center">
            <label> Product Description </label>{" "}
          </div>{" "}
          <input
            className="form-control col-6 col-md-6 col-lg-9 "
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-sm"
            type="text"
            name="ProductDescription"
            value={ProductDescription}
            onChange={onChange}
          />{" "}
        </div>{" "}
        <div className="input-group input-group-sm mb-3">
          <div className="form-control col-12 col-md-6 col-lg-3 text-center">
            <label> US Shipping Price </label>{" "}
          </div>{" "}
          <input
            className="form-control col-6 col-md-6 col-lg-9"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-sm"
            type="number"
            name="ProductShippingUS"
            value={ProductShippingUS}
            onChange={onChange}
          />{" "}
        </div>{" "}
        <div className="input-group input-group-sm mb-3">
          <div className="form-control col-12 col-md-6 col-lg-3 text-center">
            <label> Non US Shipping Price </label>{" "}
          </div>{" "}
          <input
            className="form-control col-6 col-md-6 col-lg-9"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-sm"
            type="number"
            name="ProductShippingNUS"
            value={ProductShippingNUS}
            onChange={onChange}
          />{" "}
        </div>{" "}
        <div className="input-group input-group-sm mb-3">
          <div className="form-control col-12 col-md-6 col-lg-3 text-center">
            <label> USPS </label>{" "}
          </div>{" "}
          <input
            className="form-control col-6 col-md-6 col-lg-9"
            type="number"
            name="USPS"
            value={USPS}
            onChange={onChange}
          />{" "}
        </div>
        <div>
          {" "}
          {/* start product quantity prices */}{" "}
          <div className="row justifyContent-content-start mt-3">
            <h4 className="col-sm-auto"> Product Price </h4>{" "}
            <button
              className="col-sm-auto"
              style={{
                paddingTop: "5px",
                paddingBottom: "5px",
                marginBottom: "10px",
              }}
              type="button"
              onClick={() => handleAdd()}
              className="btn btn-outline-success"
            >
              +
            </button>{" "}
          </div>
          <div
            className="overflow-auto "
            style={{
              maxHeight: "32vh",
              height: "32vh",
            }}
          >
            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <div className="input-group input-group-sm mb-3">
                    <div className="form-control col-2 text-center">
                      <label> Quantity </label>{" "}
                    </div>{" "}
                    <input
                      className="form-control col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      type="number"
                      value={Object.keys(field)}
                      name="quantity"
                      onChange={(e) => handleQuantityChange(idx, e)}
                    />{" "}
                    <div className="form-control col-2 text-center">
                      <label className="align-items-center"> Price </label>{" "}
                    </div>{" "}
                    <input
                      className="form-control col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      type="number"
                      value={Object.values(field)}
                      name="price"
                      onChange={(e) => handlePriceChange(idx, e)}
                    />{" "}
                    <div className="input-group-append">
                      <button
                        type="button"
                        onClick={() => handleRemove(idx)}
                        className="btn btn-outline-danger"
                      >
                        x{" "}
                      </button>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
              );
            })}{" "}
          </div>{" "}
        </div>
        {/* buttons start */}{" "}
        <div
          className="d-flex justifyContent-content-end"
          style={{
            marginTop: "10px",
          }}
        >
          {product.loading === true ? (
            <br> </br>
          ) : (
            <input
              type="submit"
              style={{
                borderRadius: "5px",
              }}
              value={current ? "Update Product" : "Add Product"}
              className="btn btn-info"
            />
          )}
          {current && (
            <div className="btn-group">
              <button
                style={{
                  marginLeft: "20px",
                  borderRadius: "5px",
                }}
                type="button"
                className="btn btn-light"
                onClick={clearAll}
              >
                Clear{" "}
              </button>
              <button
                style={{
                  marginLeft: "20px",
                  borderRadius: "5px",
                }}
                type="button"
                className="btn btn-danger"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                Delete{" "}
              </button>{" "}
              <div
                className="modal"
                id="exampleModal"
                tableindex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"> Confirmation </h5>{" "}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true"> & times; </span>{" "}
                      </button>{" "}
                    </div>{" "}
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this product:{" "}
                        {product.ProductID}{" "}
                      </p>{" "}
                    </div>{" "}
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Cancel{" "}
                      </button>{" "}
                      <button
                        type="button"
                        onClick={onDelete}
                        className="btn btn-danger"
                        data-dismiss="modal"
                      >
                        Delete{" "}
                      </button>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>
          )}{" "}
        </div>{" "}
        {/* button ends */}{" "}
      </form>{" "}
    </div>
  );
};

export default ProductForm;
